<template>
    <div class="container pb-5">
        <div class="px-4 py-5 text-center text-light h-50">
            <h2 class="display-4 fw-bold">AutoSolutions MCR</h2>
            <div class="col-lg-6 mx-auto">
                <p class="lead mb-4">The AutoSolutions MCR Garage Website.</p>
                <p class="lead">This site has been put together using <code>VueJS</code>. 
                    The site routing is managed by <code>Vue Router</code>.
                    The site uses <code>Tailwind CSS</code> for styling and <code>Heroicons</code> for icons! The site is built using <code>NodeJS</code> and <code>Vite</code>.
                </p>
                <p>VueJS | Vue Router | TailwindCSS | HeadlessUI | Heroicons | Vite | NodeJS</p>
                <div class="d-grid gap-2 d-sm-flex justify-content-sm-center mb-5">
                    <a href="https://autosolutionsmcr.co.uk/" class="btn btn-outline-secondary btn-lg px-4">AutoSolutions MCR</a>
                </div>
            </div>
            <div class="overflow-hidden">
                <div class="container px-5">
                    <a href="https://autosolutionsmcr.co.uk/" target="_blank"><img src="../assets/img/mcrthumbnail.png"
                            class="img-fluid border rounded-3 shadow-lg mb-4" alt="autosolutionsmcr" width="700" height="900"
                            loading="lazy"></a>
                </div>
            </div>
        </div>
    </div>
</template>